/**
 * Frontend mirror of the backend HRIS status-decision contract (DAT-319).
 * The backend surfaces open decisions per department; an admin either applies
 * the suggested status change ("changed") or records that they kept the
 * current status ("kept").
 */

export enum StatusDecisionReason {
	TermWithActivity = "term_with_activity",
	IdleNoTermWasActive = "idle_no_term_was_active",
	IdleNoTerm = "idle_no_term",
	InactiveGotActual = "inactive_got_actual",
	Rehired = "rehired",
	/** DAT-464: the employee's HRIS role now resolves to a job this department doesn't enable. */
	JobNotEnabled = "job_not_enabled",
}

export enum StatusDecisionDirection {
	Deactivate = "deactivate",
	Reactivate = "reactivate",
}

export enum StatusDecisionChoice {
	Changed = "changed",
	Kept = "kept",
}

/** Supporting evidence the backend attaches to each open decision. Dates are ISO strings. */
export interface StatusDecisionTriggerFacts {
	isActive: boolean;
	terminationDate: string | null;
	rehireDate: string | null;
	lastActualDate: string | null;
	lastScheduledDate: string | null;
	hasFutureScheduled: boolean | null;
	/** DAT-464: the job the role string resolved to — names what the scheduler has to change. */
	jobName: string | null;
}

export interface OpenStatusDecision {
	id: string;
	nurseId: number;
	reason: StatusDecisionReason;
	direction: StatusDecisionDirection;
	triggerFacts: StatusDecisionTriggerFacts;
}
